import { NavLink } from "react-router-dom";

import "../../styles/DevelopmentAdmin.css";

const navigationItems = [
  {
    label: "Dashboard",
    path: "/avwakindevelopment/admin",
    end: true,
  },
  {
    label: "Clients",
    path: "/avwakindevelopment/admin/clients",
  },
  {
    label: "Projects",
    path: "/avwakindevelopment/admin/projects",
  },
  {
    label: "Services",
    path: "/avwakindevelopment/admin/services",
  },
  {
    label: "Proposals",
    path: "/avwakindevelopment/admin/proposals",
  },
  {
    label: "Invoices",
    path: "/avwakindevelopment/admin/invoices",
  },
  {
    label: "Payments",
    path: "/avwakindevelopment/admin/payments",
  },
  {
    label: "Documents",
    path: "/avwakindevelopment/admin/documents",
  },
  {
    label: "Files",
    path: "/avwakindevelopment/admin/files",
  },
  {
    label: "Portfolio",
    path: "/avwakindevelopment/admin/portfolio",
  },
  {
    label: "Settings",
    path: "/avwakindevelopment/admin/settings",
  },
];

function DevelopmentAdminNav() {
  return (
    <aside className="development-admin-sidebar">
      <div className="development-admin-sidebar-header">
        <NavLink
          to="/avwakindevelopment/admin"
          className="development-admin-brand"
        >
          <span className="development-admin-brand-mark">
            A
          </span>

          <span className="development-admin-brand-text">
            <strong>Avwakin</strong>
            <span>Development</span>
          </span>
        </NavLink>
      </div>

      <nav
        className="development-admin-navigation"
        aria-label="Avwakin Development administration"
      >
        {navigationItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.end}
            className={({ isActive }) =>
              `development-admin-nav-link${
                isActive ? " active" : ""
              }`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="development-admin-sidebar-footer">
        <NavLink
          to="/avwakindevelopment"
          className="development-admin-public-link"
        >
          View public website
        </NavLink>
      </div>
    </aside>
  );
}

export default DevelopmentAdminNav;